import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class AuthenticatedTasProgramsShowController extends Controller {
  @tracked fromModal = false;

  queryParams = ['fromModal'];
}
